import { render, staticRenderFns } from "./CurriculumListItem.vue?vue&type=template&id=ba0b9816&scoped=true&lang=pug"
import script from "./CurriculumListItem.vue?vue&type=script&lang=js"
export * from "./CurriculumListItem.vue?vue&type=script&lang=js"
import style0 from "./CurriculumListItem.vue?vue&type=style&index=0&id=ba0b9816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0b9816",
  null
  
)

export default component.exports